<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      @if (!isloading) {
        <div class="detail-group">
          @if (!isTaskContext) {
            <div class="panel-title">
              Whitelisted Wallet details
              <button class="close-icon" (click)="onClose()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }

          <div class="detail-row">
            <div class="field-label">Wallet Address</div>
            <div class="field-value copyable-value olv-address">
              {{ shortenAddress(wallet.walletAddress) }}
              <span [matTooltip]="copyText" matTooltipPosition="above" #copyTooltip="matTooltip">
                <img
                  src="shared-assets/icons/copy.svg"
                  class="copy-icon"
                  (click)="copyToClipboard(wallet.walletAddress, copyTooltip)"
                  alt="Copy icon"
                />
              </span>
            </div>
          </div>
          <div class="detail-row">
            <div class="field-label">Blokchain</div>
            <div class="field-value">{{ wallet.blockchain }}</div>
          </div>
          <div class="detail-row">
            <div class="field-label">Wallet Name</div>
            <div class="field-value">{{ wallet.walletName }}</div>
          </div>
          <div class="detail-row">
            <div class="field-label">Prepared by</div>
            <div class="field-value">{{ wallet.preparedBy }}</div>
          </div>
          <div class="detail-row">
            <div class="field-label">Date</div>
            <div class="field-value">{{ formatDateStandard(wallet.date) }}</div>
          </div>
          @if (wallet.resolvedByDisplayName) {
            <div class="detail-row">
              <div class="field-label">Resolved by</div>
              <div class="field-value">{{ wallet.resolvedByDisplayName }}</div>
            </div>
          }
          @if (wallet.resolvedAt) {
            <div class="detail-row">
              <div class="field-label">Resolved At</div>
              <div class="field-value">{{ formatDateStandard(wallet.resolvedAt) }}</div>
            </div>
          }
          @if (wallet.resolution) {
            <div class="detail-row">
              <div class="field-label">Resolution</div>
              <div class="field-value">{{ resolutionToString(wallet.resolution) }}</div>
            </div>
          }

          @if (isSettlementApp) {
            <div class="detail-row">
              <div class="field-label">Withdrawal Type</div>
              <div class="field-value">{{ wallet.withdrawalType }}</div>
            </div>
            <div class="detail-row">
              <div class="field-label">Risk Level</div>
              <div class="field-value">
                <app-state-badge type="risk" [value]="wallet.riskLevel"></app-state-badge>
              </div>
            </div>
          }

          <div class="detail-row">
            <div class="field-label">Status</div>
            <div class="field-value">
              <app-state-badge [status]="wallet.status"></app-state-badge>
            </div>
          </div>
          <div class="detail-row">
            <div class="field-label">Attachment</div>
            @if (wallet.documentId) {
              <div class="field-value document" (click)="getAttachment(wallet.documentId)">
                <img src="shared-assets/icons/document.png" alt="Document Icon" />
                {{ wallet.documentName || 'Document' }}
              </div>
            } @else {
              <div class="field-value">No attachment</div>
            }
          </div>

          @if (wallet.status !== 'Pending') {
            <ng-container *ngTemplateOutlet="commentsBlock"></ng-container>
          }
        </div>
      }
      @if (whitelistedError) {
        <div class="error-message" role="alert">
          <mat-icon class="error-icon">error</mat-icon>
          {{ whitelistedError }}
        </div>
      }
    </div>
    @if (!isloading) {
      <div class="sidebar-actions">
        @if (wallet.status === 'Pending' && wallet.canApproveOrReject) {
          <ng-container *ngTemplateOutlet="commentsBlock"></ng-container>

          <ng-container *appHasPermission="{ resource: permissionResource, scope: Scopes.Approve }">
            <app-button
              buttonVariant="primary"
              buttonType="button"
              [state]="approveButtonState"
              (buttonClick)="openOTP()"
            >
              Approve
            </app-button>
          </ng-container>

          <ng-container *appHasPermission="{ resource: permissionResource, scope: Scopes.Reject }">
            <app-button
              buttonVariant="sidebar-danger"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="handleWalletAction('reject')"
            >
              Reject
            </app-button>
          </ng-container>
        }
        @if (wallet.status === 'Approved') {
          <ng-container *appHasPermission="{ resource: permissionResource, scope: Scopes.Revoke }">
            <app-button
              buttonVariant="sidebar-danger"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="handleWalletAction('revoke')"
            >
              Revoke
            </app-button>
          </ng-container>
        }
      </div>
    } @else {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading..."></app-loading-spinner>
      </div>
    }
  </div>
</div>
<ng-template #commentsBlock>
  <div class="comments-heading">Comments</div>
  <form [formGroup]="merchantForm">
    <textarea
      formControlName="commentText"
      class="comment-box"
      aria-label="Comments"
      data-gramm="false"
      [placeholder]="canApproveOrReject ? 'Enter your comment' : ''"
    ></textarea>

    @if (getFieldError('commentText', 'Comments') !== '') {
      <div class="error-message" role="alert">
        {{
          getFieldError('commentText', 'Comments', {
            invalidText: 'Comments contain invalid characters.',
          })
        }}
      </div>
    }
  </form>
</ng-template>
